import { useQuery } from '@tanstack/react-query';
import { endpoints } from 'endpoints/endpoints';
import axiosInstance from 'utils/axiosInstance';
import { setToast, toastConfig } from 'utils/commonUtil';

// export const useGetJobUrlId = ({ id }) => {
//   return useQuery({
//     queryKey: ['getJobByUrlId', id],
//     queryFn: async () => {
//       return await axiosInstance
//         .get(`${endpoints.jobs}/findByJobId/${id}`)
//         .then((res) => {
//           if (res?.status == 200) {
//             return res?.data?.data;
//           } else {
//             return [];
//           }
//         })
//         .catch((e) => {
//           toastConfig.type = 'error';
//           setToast(toastConfig, e.response.data.e);
//           console.log(e);
//         });
//     },
//     onSuccess: ({ data }) => {
//       return data;
//     }
//   });
// };
// http://localhost:5500/api/v1/jobs/public/67ae342c47b5ea2d28d3c2d8

export const useGetJobUrlNewId = ({ id }) => {
  return useQuery({
    queryKey: ['getJobByUrlNewId', id],
    queryFn: async () => {
      return await axiosInstance
        .get(`${endpoints.jobs}/public/${id}`)
        .then((res) => {
          // console.log('🚀 ~ .then ~ res:', res);
          if (res?.status == 200) {
            return res?.data?.data;
          } else {
            return [];
          }
        })
        .catch((e) => {
          toastConfig.type = 'error';
          setToast(toastConfig, e.response.data.e);
          console.log(e);
        });
    },
    onSuccess: ({ data }) => {
      return data;
    }
  });
};

//Crush Report Job Url
//http://localhost:5500/api/v1/jobs/crush-report/public/67ae342c47b5ea2d28d3c2d8

export const useGetJobUrlNewPdf = ({ id }) => {
  // const queryClient = useQueryClient();
  return useQuery({
    queryKey: ['getJobUrlNewPdf', id],
    queryFn: async () => {
      return await axiosInstance
        .get(`${endpoints.jobs}/crush-report/public/${id}`)
        .then((res) => {
          if (res?.status == 200) {
            return res?.data;
          } else {
            return [];
          }
        })
        .catch((e) => {
          toastConfig.type = 'error';
          setToast(toastConfig, e.response.data.e);
          console.log(e);
          /* The line `console.log('🚀 ~ useGetJobUrlNewPdf ~ error:', error);` is a console log statement
        in JavaScript. */
        });
    },
    enabled: Boolean(id),
    onError: (error) => {
      console.log('🚀 ~ useGetJobUrlNewPdf ~ error:', error?.response?.data?.error);
      return error;
    }
    // onSuccess: ({ data }) => {
    //   queryClient.refetchQueries({
    //     queryKey: ['getJobById'],
    //     type: 'active'
    //   });
    //   return data;
    // }
  });
};
